import React from 'react'
const Motor = () => {
  return (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="3.66732" cy="7.73958" r="2.66667" stroke="black" strokeWidth="1.33333" />
      <circle cx="11.3333" cy="8.73958" r="1.66667" stroke="black" strokeWidth="1.33333" />
      <path
        d="M3.75029 8.07916L7.08363 2.07916L3.75029 2.07916"
        stroke="black"
        strokeWidth="1.33333"
        strokeLinejoin="round"
      />
      <path
        d="M10.418 7.44141L12.3411 3.97984L13.668 3.97984"
        stroke="black"
        strokeWidth="1.33333"
        strokeLinejoin="round"
      />
      <path d="M6.24895 3.40574L10.0013 7.40372" stroke="black" strokeWidth="1.33333" />
    </svg>
  )
}

export default Motor
